var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "sidebar" } },
    [
      _c(
        "Menu",
        {
          ref: "menu",
          attrs: {
            accordion: "",
            theme: "dark",
            width: "auto",
            "active-name": _vm.menuActive,
            "open-names": [_vm.menuOpened],
          },
          on: { "on-select": _vm.handleMenuSelect },
        },
        [
          _vm._l(_vm.menu, function (item) {
            return [
              !item.children
                ? _c(
                    "MenuItem",
                    { key: item.path, attrs: { name: item.path } },
                    [
                      _c("Icon", { attrs: { type: "md-speedometer" } }),
                      _vm._v(_vm._s(item.name) + "\r\n      "),
                    ],
                    1
                  )
                : _c(
                    "Submenu",
                    { key: item.path, attrs: { name: item.path } },
                    [
                      _c(
                        "template",
                        { slot: "title" },
                        [
                          item.icon
                            ? _c("Icon", { attrs: { type: item.icon } })
                            : _vm._e(),
                          _vm._v(_vm._s(item.name) + "\r\n        "),
                        ],
                        1
                      ),
                      _vm._l(item.children, function (child) {
                        return [
                          !child.children
                            ? _c(
                                "MenuItem",
                                { attrs: { name: child.path } },
                                [
                                  child.icon
                                    ? _c("Icon", {
                                        attrs: { type: child.icon },
                                      })
                                    : _vm._e(),
                                  _vm._v(_vm._s(child.name) + "\r\n          "),
                                ],
                                1
                              )
                            : _vm._e(),
                          child.children
                            ? _c(
                                "Submenu",
                                {
                                  key: child.path,
                                  attrs: { name: child.path },
                                },
                                [
                                  _c(
                                    "template",
                                    { slot: "title" },
                                    [
                                      child.icon
                                        ? _c("Icon", {
                                            attrs: { type: child.icon },
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        _vm._s(child.name) + "\r\n            "
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._l(
                                    child.children,
                                    function (secondChild) {
                                      return _c(
                                        "MenuItem",
                                        {
                                          key: secondChild.path,
                                          attrs: { name: secondChild.path },
                                        },
                                        [
                                          secondChild.icon
                                            ? _c("Icon", {
                                                attrs: {
                                                  type: secondChild.icon,
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(
                                            _vm._s(secondChild.name) +
                                              "\r\n            "
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                ],
                                2
                              )
                            : _vm._e(),
                        ]
                      }),
                    ],
                    2
                  ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }